(function () {
  function closeOverlay(overlay) {
    const modal = overlay.querySelector('#size-guide-modal');
    const overlayBtn = overlay.querySelector('#size-guide-overlay-btn');
    const isMobile = window.innerWidth < 768;
    if (overlayBtn) overlayBtn.style.opacity = '0';
    if (modal) {
      if (isMobile) {
        modal.style.transform = 'translateY(100%)';
      } else {
        modal.style.transform = 'translate(-50%, -50%) scale(0.95)';
        modal.style.opacity = '0';
      }
    }
    setTimeout(() => {
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    }, 300);
  }

  document.body.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.open-size-guide');
    if (openBtn) {
      e.preventDefault();
      const scope = openBtn.closest('.main-product-d5') || document;
      const overlay = scope.querySelector('#size-guide-overlay');
      if (!overlay) return;
      const modal = overlay.querySelector('#size-guide-modal');
      const overlayBtn = overlay.querySelector('#size-guide-overlay-btn');
      const isMobile = window.innerWidth < 768;
      overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      if (modal) {
        if (isMobile) {
          modal.style.transform = 'translateY(100%)';
        } else {
          modal.style.transform = 'translate(-50%, -50%) scale(0.95)';
          modal.style.opacity = '0';
        }
      }
      setTimeout(() => {
        if (overlayBtn) overlayBtn.style.opacity = '1';
        if (modal) {
          if (isMobile) {
            modal.style.transform = 'translateY(0)';
          } else {
            modal.style.transform = 'translate(-50%, -50%) scale(1)';
            modal.style.opacity = '1';
          }
        }
      }, 10);
      return;
    }

    const closeTarget = e.target.closest('#size-guide-close-btn, #size-guide-overlay-btn');
    if (closeTarget) {
      e.preventDefault();
      const overlay = closeTarget.closest('#size-guide-overlay');
      if (overlay) closeOverlay(overlay);
      return;
    }

    const unitBtn = e.target.closest('.unit-toggle-btn');
    if (unitBtn) {
      const overlay = unitBtn.closest('#size-guide-overlay');
      if (!overlay) return;
      const unit = unitBtn.dataset.unit;
      overlay.querySelectorAll('.unit-toggle-btn').forEach(b => {
        const innerDiv = b.querySelector('div');
        if (!innerDiv) return;
        if (b.dataset.unit === unit) {
          innerDiv.classList.add('bg-neutral-100', 'rounded-full', 'border-4', 'border-[rgba(0,0,0,0.1)]');
          innerDiv.classList.remove('ml-1.5');
        } else {
          innerDiv.classList.remove('bg-neutral-100', 'rounded-full', 'border-4', 'border-[rgba(0,0,0,0.1)]');
          if (b.dataset.unit === 'cm') innerDiv.classList.add('ml-1.5');
        }
      });
      overlay.querySelectorAll('[data-unit-table]').forEach(table => {
        if (table.dataset.unitTable === unit) table.classList.remove('hidden');
        else table.classList.add('hidden');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('#size-guide-overlay').forEach(overlay => {
      if (!overlay.classList.contains('hidden')) closeOverlay(overlay);
    });
  });
})();
